import styled, { css } from 'styled-components';
export const AlertContainer = styled.div `
  // estilos generales
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${({ theme, variant }) => theme.colors[variant].normal};
  background-color: ${({ theme, variant }) => theme.colors[variant].lighten};
  padding: 10px;

  // alineacion del contenido
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  // animación de opacidad
  transition: opacity 0.3s ease;
  opacity: ${({ hide }) => (hide ? 0 : 1)};

  // Hide
  ${({ hide }) => hide &&
    css `
      pointer-events: none;
      overflow: hidden;
    `}

  // Close
  ${({ close }) => close &&
    css `
      display: none;
    `}
`;
export const ContentWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 4px;
`;
export const IconWrapper = styled.span `
  margin-top: 3px;
`;
export const TextContent = styled.p `
  font-family: ${({ theme }) => theme.fonts.families.primary};
  margin: 2px 0px 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
export const DescriptionContent = styled.span `
  word-wrap: break-word;
  margin-right: 4px;
`;
export const TitleContent = styled(DescriptionContent) `
  font-weight: 600;
  margin-right: 4px;
`;
export const AlertLink = styled.a `
  font-family: ${({ theme }) => theme.fonts.families.primary};
  color: ${({ theme }) => theme.colors.secondary.normal};
  font-weight: 600;
`;
export const CloseButton = styled.button `
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0px;
  outline: none;

  &:hover {
    cursor: pointer;
  }
`;
